import Feature from "src/js/stores/user/Feature";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import { ComparablesFilterFields } from "../components/Filters/FiltersWithClear";

export const hiddenFieldsByFeature: Array<[() => boolean, Set<ComparablesFilterFields>]> = [
  [() => hasFeature(Feature.usAccess), new Set(["newBuildsOnly", "tenure"])],
  // Year built is shown in sites card for US; for non-US without Zoopla full access, hide year built and bedrooms
  [
    () => !hasFeature(Feature.zooplaFullAccess) && !hasFeature(Feature.usAccess),
    new Set<ComparablesFilterFields>(["bedrooms", "yearBuiltFrom", "yearBuiltTo"]),
  ],
];
